module.exports = {"name":"bellCount","audiences":["alphaMembers","allMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":1},"defaultWeight":1,"experimentVersion":"v1","defaults":{"showCount":false,"markBell":false},"variations":[{"name":"countAll","weight":1,"values":{"showCount":true,"markBell":false}},{"name":"markBell","weight":1,"values":{"showCount":false,"markBell":true}},{"name":"countUnseenMarkBell","weight":1,"values":{"showCount":true,"markBell":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/bellCount.json
// module id = CGGu
// module chunks = 1